module.exports = __webpack_public_path__ + "static/media/trains_to_other.eae5c8a1.png";